import { render, staticRenderFns } from "./GreetJob.vue?vue&type=template&id=64bfa278&scoped=true"
import script from "./GreetJob.vue?vue&type=script&lang=js"
export * from "./GreetJob.vue?vue&type=script&lang=js"
import style0 from "./GreetJob.vue?vue&type=style&index=0&id=64bfa278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bfa278",
  null
  
)

export default component.exports